// @flow
import Router from 'next/router'
import type { Action, TypedItemAction } from '../../types/Action'
import type { Driver as Chauffeur } from '../../types/Driver'
import type { JsonApiError } from '../../types/JsonApi'

let isRouteChangeCallbackSet = false

export function onRouteChange () {
  global.rg4js('trackEvent', {
    type: 'pageView',
    path: Router.pathname
  })
}
export function onLogin (action: TypedItemAction<Chauffeur>) {
  if (!isRouteChangeCallbackSet) {
    Router.events.on('routeChangeComplete', () => onRouteChange())
    isRouteChangeCallbackSet = true
  }
  global.rg4js('setUser', {
    isAnonymous: false,
    identifier: action.payload.id
  })
}

export function onLogout () {
  global.rg4js('setUser', {
    isAnonymous: true,
    identifier: ''
  })
}

export function onApiFailure (response: { payload: Array<any> }) {
  // Known and well handled errors
  // 401: unauthorized / user is not logged in
  // 403: forbidden / user does not have enough rights to access a resource
  // 404: not found / resource missing
  // 422: Unprocessable Entity / s3 or DMS errors, validation, bid, ...
  const knownErrors = ['401', '403', '404', '422']
  ;[].concat(response.payload).map((error = {}) => {
    const status = String(error.status || error.message || 'unknown')
    try {
      if (knownErrors.includes(status)) {
        return
      }
      throw new Error(`API failure: ${status}`)
    } catch (e) {
      global.rg4js('send', {
        error: e,
        tags: ['api-error'],
        customData: { ...response, error: e }
      })
    }
  })
}
